import React from 'react';
import isFunction from 'lodash/isFunction';
import Input from '@lightspeed/cirrus-input';
import FormField from 'cirrus/FormField';

const FormikInput = ({
  field,
  form: { touched, errors, setFieldValue, setFieldTouched },
  required,
  label,
  description,
  textHelper,
  children,
  ...rest
}) => {
  const shouldShowError = Boolean(errors[field.name] && touched[field.name]);

  const labelProps = {
    id: field.name,
    label,
    description,
    textHelper,
    status: shouldShowError
      ? {
          type: 'error',
          message: errors[field.name],
        }
      : null,
  };

  const inputProps = {
    id: field.name,
    ...field,
    ...rest,
    setFieldValue,
    setFieldTouched,
    status: shouldShowError ? { type: 'error' } : null,
  };

  return (
    <FormField {...labelProps}>
      {children ? ( // eslint-disable-line no-nested-ternary
        isFunction(children) ? (
          children(inputProps)
        ) : (
          React.Children.map(children, child => React.cloneElement(child, { ...inputProps }))
        )
      ) : (
        <Input {...inputProps} />
      )}
    </FormField>
  );
};

export default FormikInput;
